import { DateFormatterIdn } from '@diamond/shared/utils';

export function formatNlbUpdatedAt(
  lastUpdatedAt: string | null | undefined
): string {
  if (!lastUpdatedAt) {
    return '-';
  }

  return DateFormatterIdn(lastUpdatedAt);
}
